import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { StatsBanner } from './components/StatsBanner';
import { ProblemSection } from './components/ProblemSection';
import { ScienceSection } from './components/ScienceSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { ResultsSection } from './components/ResultsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-sage selection:text-brand-forest" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBanner data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <ScienceSection data-id="element-6" />
        <WhatsInsideSection data-id="element-7" />
        <ResultsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <FinalCTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}